$(function () {
	$('[data-hatch-calculator]').each(function () {
		const $root = $(this);
		const config = $root.data('settings');
		const $inputs = $root.find('[data-calculator-inputs]');
		const $button = $root.find('[data-quote-button]');
		const $outcome = $root.find('[data-calculator-outcome]');
		const $result = $root.find('[data-calculator-result]');
		const $panels = $root.find('[data-order-panel]');
		const $fullForm = $root.find('[data-calculator-order="full"]');
		const $shortForm = $root.find('[data-calculator-order="short"]');
		let selected = null;
		let pending = null;
		let revision = 0;
		let quote = null;
		const format = value => Number(value).toLocaleString('ru-RU', {maximumFractionDigits: 2});
		const dimensions = data => selected.type === 'tiles' ? {
			width: data.tiles_x * data.tile_width,
			height: data.tiles_y * data.tile_height
		} : {width: data.opening_width, height: data.opening_height};
		const read = () => {
			if (!selected || !$inputs.length || !$inputs[0].checkValidity()) return null;
			const data = {serie_id: selected.id};
			$inputs.serializeArray().forEach(field => { data[field.name] = Number(field.value); });
			return data;
		};
		const sizeText = size => format(size.height) + '\u00a0×\u00a0' + format(size.width) + '\u00a0мм';
		const setContext = ($form, data) => {
			const $context = $form.find('[data-calculation-context]').empty();
			Object.keys(data || {}).forEach(key => $('<input>', {type: 'hidden', name: key, value: data[key]}).appendTo($context));
			$form.find('[data-order-summary]').prop('hidden', !data).text(data ? selected.title + '\u00a0·\u00a0' + sizeText(dimensions(data)) : '');
		};
		const fillFullForm = data => {
			setContext($fullForm, data);
			if (!data) return;
			const size = dimensions(data);
			$fullForm.find('[name="width"]').val(Number(size.width.toFixed(2)));
			$fullForm.find('[name="height"]').val(Number(size.height.toFixed(2)));
			const type = selected.type === 'tiles' ? 'Под плитку' : 'Под покраску';
			$fullForm.find('[name="type"] option').each(function () { this.selected = this.value === type; });
		};
		const showResult = (result, data) => {
			quote = result;
			// Разметка карточки приходит с сервера: цена, ссылка и подписи имеют один источник.
			$result.html(result.html);
			const full = result.status === 'unavailable' && $fullForm.length > 0;
			$panels.prop('hidden', true).filter('[data-order-panel="' + (full ? 'full' : 'short') + '"]').prop('hidden', false);
			if (full) fillFullForm(data); else setContext($shortForm, data);
			$outcome.prop('hidden', false);
			$result[0].focus({preventScroll: true});
			$outcome[0].scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
		};
		const invalidate = () => {
			revision++;
			if (pending) { pending.abort(); pending = null; }
			quote = null;
			$button.prop('disabled', false).text(config.selection.button);
			$outcome.prop('hidden', true);
			$root.find('[data-calculator-error]').prop('hidden', true);
			$root.find('[data-calculation-context]').empty();
		};
		const redraw = () => {
			invalidate();
			const data = read();
			const $grid = $root.find('[data-diagram-tiles]').empty();
			$root.find('[data-size-diagram]').prop('hidden', !data);
			$inputs.find('input').each(function () {
				const value = Number(this.value);
				$(this).siblings('[data-step="-1"]').prop('disabled', value <= Number(this.min));
				$(this).siblings('[data-step="1"]').prop('disabled', value >= Number(this.max));
			});
			if (!data) {
				$root.find('[data-size-summary]').text('Проверьте указанные размеры');
				return;
			}
			const size = dimensions(data);
			const scale = Math.min(270 / size.width, 230 / size.height);
			const width = size.width * scale, height = size.height * scale;
			const x = 45 + (270 - width) / 2, y = 25 + (230 - height) / 2;
			// Паттерн не создаёт тысячи узлов даже при расчёте мелкой мозаики.
			const ns = 'http://www.w3.org/2000/svg';
			const add = (tag, attrs, parent) => {
				const element = document.createElementNS(ns, tag);
				Object.keys(attrs).forEach(key => element.setAttribute(key, attrs[key]));
				parent.appendChild(element);
				return element;
			};
			const pattern = add('pattern', {id: 'hatch-tile-pattern', patternUnits: 'userSpaceOnUse', x, y,
				width: selected.type === 'tiles' ? data.tile_width * scale : width,
				height: selected.type === 'tiles' ? data.tile_height * scale : height}, $grid[0]);
			add('rect', {width: selected.type === 'tiles' ? data.tile_width * scale : width,
				height: selected.type === 'tiles' ? data.tile_height * scale : height}, pattern);
			const frame = add('rect', {x, y, width, height}, $grid[0]);
			frame.style.fill = 'url(#hatch-tile-pattern)';
			$root.find('[data-width-label]').text(format(size.width) + ' мм');
			$root.find('[data-height-label]').text(format(size.height) + ' мм');
			$root.find('[data-size-summary]').text((selected.type === 'tiles' ? 'Раскладка: ' : 'Проём: ') + sizeText(size));
		};
		$root.on('change', '[name="calculator_serie"]', function () {
			selected = {id: Number(this.value), type: $(this).data('calculator-type'), title: $(this).data('title'), url: $(this).data('serie-url')};
			const $workspace = $root.find('[data-calculator-workspace]').prop('hidden', false);
			$root.find('[data-choose-hint]').prop('hidden', true);
			$root.find('[data-selected-title]').text(selected.title);
			$root.find('[data-selected-series-link]').attr('href', selected.url);
			$root.find('[data-dimension-note]').text(config.selection[selected.type === 'tiles' ? 'tiles_note' : 'opening_note']);
			$inputs.find('[data-mode]').each(function () {
				const active = $(this).data('mode') === selected.type;
				$(this).prop('disabled', !active).prop('hidden', !active);
			});
			redraw();
			if (window.matchMedia('(max-width: 767px)').matches) {
				requestAnimationFrame(() => $workspace[0].scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'}));
			}
		});
		$inputs.on('input change', 'input', redraw);
		$inputs.on('click', '[data-step]', function () {
			const input = $(this).siblings('input')[0];
			if ($(this).data('step') > 0) input.stepUp(); else input.stepDown();
			$(input).trigger('input');
		});
		$inputs.on('submit', function (event) {
			event.preventDefault();
			const data = read();
			if (!data) { this.reportValidity(); return; }
			invalidate();
			const requestRevision = revision;
			$button.prop('disabled', true).text(config.selection.loading);
			pending = $.getJSON($root.data('quote-url'), data).done(function (result) {
				if (requestRevision !== revision) return;
				showResult(result, data);
			}).fail(function (xhr, status) {
				if (status === 'abort' || requestRevision !== revision) return;
				const errors = xhr.responseJSON && xhr.responseJSON.errors;
				const message = errors ? Object.values(errors).flat().join(' ') : config.selection.error;
				$root.find('[data-calculator-error]').prop('hidden', false).text(message);
			}).always(function () {
				if (requestRevision === revision) {
					pending = null;
					$button.prop('disabled', false).text(config.selection.button);
				}
			});
		});
		// Контакты не теряются при переходе между короткой и полной формой.
		$root.on('input', '[data-calculator-order] [name^="user_"]', function () {
			const source = this;
			$root.find('[data-calculator-order] [name="' + source.name + '"]').not(source).val(source.value);
		});
		$root.on('submit', '[data-calculator-order="short"]', function (event) {
			if (!quote || !read()) { event.preventDefault(); event.stopImmediatePropagation(); return false; }
			setContext($(this), read());
		});
		$root.on('submit-success', '[data-calculator-order]', function () {
			$root.find('[data-calculator-order] [name^="user_"]').val('');
		});
		const requestedSerie = new URLSearchParams(window.location.search).get('serie_id');
		if (requestedSerie) $root.find('[name="calculator_serie"]').filter(function () { return this.value === requestedSerie; }).prop('checked', true).trigger('change');
	});
});
